import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

const FloatingButtons = () => {
    return (
        /* Mobile aur Desktop dono ke liye position set ki hai taaki mute button na chhipe */
        <div className="fixed bottom-24 right-3 md:bottom-28 md:right-6 z-40 flex flex-col gap-3">
            {/* WhatsApp Floating Button */}
            <a
                href="https://wa.me/919999320112"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white p-3 md:p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center w-12 h-12 md:w-14 md:h-14"
                title="Chat on WhatsApp"
            >
                <FaWhatsapp className="text-xl md:text-2xl" />
            </a>

            {/* Call Floating Button */}
            <a
                href="tel:+919999320112"
                className="bg-[#f15a24] hover:bg-orange-600 text-white p-3 md:p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center w-12 h-12 md:w-14 md:h-14"
                title="Call Us"
            >
                <FaPhoneAlt className="text-lg md:text-xl" />
            </a>
        </div>
    );
};

export default FloatingButtons;